/* global globalThis */
import ReactDOM from "react-dom/client";
import "bootstrap/scss/bootstrap.scss";
import "./style.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import ErrorComponent from "./utils/ErrorComponent/ErrorComponent";
import {
  handleChunkError,
  initChunkErrorHandler,
} from "./utils/chunkErrorHandler";
import { initKeycloak } from "./auth/Keycloak";

initChunkErrorHandler();

globalThis?.IS_SSO_ENABLED === "TRUE"
  ? initKeycloak(() => {
      renderApp();
    })
  : renderApp();

function renderApp() {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <BrowserRouter 
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <ErrorBoundary
        FallbackComponent={ErrorComponent}
        onError={handleChunkError}
      >
        <App />
      </ErrorBoundary>
    </BrowserRouter>
  );
}
